var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 926.632,
    height: 785.974,
    viewBox: "0 0 926.632 785.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(-0.003 -0.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1030.89,386.059c-46.34,59.26-133.78,72.83-206.13,52.19a335.509,335.509,0,0,1-68.1-28.35c-12.54-6.81-24.78-14.28-36.77-22.24-2.95-1.95-5.9-3.93-8.82-5.95q-2.985-2.04-5.95-4.13c-24.76-17.42-48.55-36.53-71.94-55.53-58.39-47.43-118.38-96.32-190.12-118.95-14.78-4.66-33.9-6.84-43.04,5.68-7.93,10.87-3.09,26.26,3.62,37.92,24.89,43.19,70.07,70.46,115.29,91.43s93.12,37.96,132.43,68.62,69.32,79.39,61.28,128.58c-6.93,42.39-41.54,76.83-81.78,91.84s-85.12,12.91-126.95,3.17-81.54-26.76-121.91-41.42c-24.34-8.85-56.16-14.97-72.31,5.28-13.64,17.11-5.8,44.1,10.81,58.34s39.09,19.01,60.54,23.29q99.9,19.95,199.8,39.89c20.43,4.07,41.34,8.33,59.14,19.17s32.16,29.75,31.65,50.58c-.51,20.53-15.54,38.67-33.96,47.76s-39.67,10.48-60.18,9.5c-76.86-3.68-297.21-125.79-350.06-141.4-33.96-10.02-71.09-24.74-85.41-57.12-17.83-40.31,11.51-89.08,51.56-107.49s86.46-14.34,130.1-8.14,88.72,14.09,131.2,2.31,81.4-50.18,77.21-94.06c-3.65-38.18-38.04-66.95-74.23-79.63-28.33-9.93-58.47-12.63-88.229-17.1-8.26-1.23-16.49-2.61-24.64-4.31a307.083,307.083,0,0,1-60.75-19.5,312.922,312.922,0,0,1-58.04-33.31,305.262,305.262,0,0,1-40.32-35.01q-2.835-2.94-5.61-6.01c-1.76-1.96-3.5-3.96-5.2-6-22.12-26.43-38.46-58.98-33.56-92.52,4.89-33.45,30.96-61.3,62-74.68,17.94-7.73,37.29-11.19,56.88-11.69a233.8,233.8,0,0,1,42.78,3.08c65.41,10.46,125.35,42.24,181.96,76.65s111.76,72.18,173.29,96.71,131.57,34.93,193.99,12.74,113.7-82.7,110.65-148.87c41.4,35.65,76.58,80.46,92.16,132.82S1064.54,343.019,1030.89,386.059Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.278,
    cy: 7.278,
    r: 7.278,
    transform: "translate(588.633 246.116)",
    fill: "#dbf205"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 11.252,
    cy: 11.252,
    r: 11.252,
    transform: "translate(841.659 146.142)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 4.157,
    cy: 4.157,
    r: 4.157,
    transform: "translate(110.754 507.237)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M370.927,329.4a44.429,44.429,0,0,1-1.3,10.7c-8.26-1.23-16.49-2.61-24.64-4.31a307.084,307.084,0,0,1-60.75-19.5,44.337,44.337,0,0,1,86.69,13.11Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#edd15f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(776.659 226.142)",
    fill: "#edbd4e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(387.659 694.142)",
    fill: "#edbd4e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(448.659 753.142)",
    fill: "#edbd4e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(71.659 585.142)",
    fill: "#20dff5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(280.659 506.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(259.659 84.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(516.659 417.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(548.659 491.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M291.527,220.728q9.075-2.739,17.362-5.935c33.96-13.117,53.438-30.911,53.438-48.82s-19.478-35.7-53.438-48.82q-5.038-1.946-10.386-3.723a136.34,136.34,0,0,1-6.976,107.3Z",
    transform: "translate(-136.684 -57.003)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M306.326,158.969a135.44,135.44,0,0,1-14.8,61.76q-1.935,3.78-4.1,7.43a136.431,136.431,0,0,1-61.23,54.82,305.266,305.266,0,0,1-40.32-35.01q-2.835-2.94-5.61-6.01c-1.76-1.96-3.5-3.96-5.2-6-22.12-26.43-38.46-58.98-33.56-92.52,4.89-33.45,30.96-61.3,62-74.68,17.94-7.73,37.29-11.19,56.88-11.69a136.127,136.127,0,0,1,35.33,49.16c1,2.37,1.92,4.77,2.79,7.2a135.756,135.756,0,0,1,7.82,45.54Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#f28482"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M368.326,165.969c0,20.83-20.34,40.15-57.28,54.42-7.39,2.86-15.3,5.45-23.62,7.77-31.14,8.68-68.2,13.49-107.16,13.8-1.76-1.96-3.5-3.96-5.2-6,.42.01.84.01,1.26.01,42.31,0,82.45-5.36,115.2-15.24,6.05-1.83,11.85-3.81,17.36-5.94,33.96-13.11,53.44-30.91,53.44-48.82s-19.48-35.7-53.44-48.82q-5.04-1.95-10.38-3.72c-.87-2.43-1.79-4.83-2.79-7.2q7.98,2.49,15.33,5.32C347.987,125.819,368.326,145.149,368.326,165.969Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(41.659 26.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(130.659 53.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 41.348,
    cy: 41.348,
    r: 41.348,
    transform: "translate(47.562 59.046)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M989.2,376.239c-9.28,2.74-29.74,4.76-52.24,6s-47.16,1.77-71.52,2.29q-63.959,1.38-127.91,2.77-8.791.2-17.64.36c-2.95-1.95-5.9-3.93-8.82-5.95,5.23.03,10.46,0,15.65-.1,22.17-.44,40.94-2.17,62.32-2.99,32.9-1.27,68.42-.27,102.71.24S965.106,379.189,989.2,376.239Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M334.767,691.47,198.846,578.239,330.891,696.005a3.151,3.151,0,1,0,3.876-4.535Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    transform: "translate(90.659 197.142)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M452.017,694.074H469.6l8.367-67.837H452.014Z",
    transform: "translate(-20.085)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M584.215,745.335h4.95l19.327-7.86,10.359,7.859h0A22.074,22.074,0,0,1,640.925,767.4v.718l-56.708,0Z",
    transform: "translate(-154.684 -57.003)",
    fill: "#9c9bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M320.308,694.074H302.721l-8.367-67.837h25.957Z",
    transform: "translate(28)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M461.477,768.125l-56.708,0v-.717a22.073,22.073,0,0,1,22.071-22.072h0l10.359-7.859,19.327,7.86h4.95Z",
    transform: "translate(-109.684 -57.003)",
    fill: "#9c9bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M520.009,231.191,502.2,244.751l-28.355,8.271s8,123.216,0,131.216-.785,8.215-2.392,18.608-8.013,37.831-8.013,37.831H584.628s1.138-17.052-5.822-20.745-1.425-33.576.728-52.576,8.653-112.833,8.653-112.833L563.07,242.31l-7.013-8.9-20.68-1.274Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#f28482"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 6.161,
    cy: 6.161,
    r: 6.161,
    transform: "translate(399.384 268.167)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M452.384,440.678l-4.963,270.731s.118,9.1,2.3,13.1a5.818,5.818,0,0,0,6.429,2.911s16.491,1.456,21.513-2.911c2.35-2.044,9.333-44.819,9.333-44.819L512.649,501.81l19.014,93.212,12,93.333s2,31.461,8.667,39.064c6.307,7.192,19.192,6.467,30.417,3.353.353-.1-.577.167,0,0,10.683-3.1,8.745-8.776,8.5-12-5.223-68.586-17.076-278.1-17.076-278.1Z",
    transform: "translate(-125.993 -57.003)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 29.839,
    cy: 29.839,
    r: 29.839,
    transform: "translate(371.978 105.576)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M452.85,269.414l5.822,4.367,2.911-20.378Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M457.687,257.163s-7.278-1.456-11.644,11.644-20.378,62.588-20.378,71.322,99.71,47.267,99.71,47.267L515,351l-45.669-23.971Z",
    transform: "translate(-119.684 -61.003)",
    fill: "#f28482"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(376.316 290.997)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M331.316,252l1.331,18.029,42.231,22.166L337.316,267Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M569.523,311.57h-.548V296.562a8.686,8.686,0,0,0-8.686-8.686h-31.8a8.686,8.686,0,0,0-8.686,8.686V378.9a8.686,8.686,0,0,0,8.686,8.686h31.8a8.686,8.686,0,0,0,8.686-8.686V322.254h.548Z",
    transform: "translate(-136.684 -57.003)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 7.278,
    cy: 7.278,
    r: 7.278,
    transform: "translate(400.817 253.014)",
    fill: "#dbf205"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M330.514,306.41,379.316,328l-50.158-9.8Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M505.812,253.773c-2.762-6.85-1.125-23.55-1.125-23.55s1.7-5.7,1.125-16.45-3.419-26.55-3.419-26.55c-1.069-4.068-.24-12.668,0-16.868s2.022-8.533,5.56-10.808,8.939-1.738,11.216,1.8c.433-5.648,5.57-9.992,11.022-11.531s11.239-.93,16.9-.671,11.933,3.25,11.933,3.25a25.326,25.326,0,0,1,9.292,8.952c3.567,6.057,5,15.052,5,15.052s-6.682,14.294-6.941,12.653c-.607-3.843,2.537,9.922,0,6.972s4.721-1.465,1.116,0c-2.022.822-.8.8-11-2.2-13-4.6-16.6-12-20.8-15.49s-11.149-7.471-15.6-7.977c-2.787-.317-5.882,8.27-7.984,10.127-1.446,1.5-3.616,3.341-1.616,6.741-.374,1.548,0,19.4,4.2,31.2s.81,14.174,0,19.4c.6,9,6.4,17.757,5.4,23.8-.29,1.763-2.2,19.461-3.8,21.4-2.452,2.969-13-10.4-13-10.4",
    transform: "translate(-136.684 -57.003)",
    fill: "#d9b380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M506.087,212.623l-3.694-25.4s-1.081-9.45,0-16.868,2.022-8.533,5.56-10.808,8.939-1.738,11.216,1.8c.433-5.648,5.57-9.992,11.022-11.531s11.239-.93,16.9-.671,27.658,22.708,26.2,27.478c0,0,10.6,60.4,4.6,76.6-1.578,4.261-10.4,23.15-14.2,23.6s3.067,4-4.667-12.2.343-15.5,0-30.6c-.246-10.822,7.609-43.331,7.35-44.972-.607-3.843-1.687-7.768-4.224-10.718s-6.846-4.659-10.451-3.194c-2.022.822-3.565,2.489-5.391,3.686-3.746,2.455,2.834-10.7-1.618-11.2s-11.349,3.238-15.8,2.732c-1.365-.155-10.839-1.173-14.6,1.268-3.413,2.214-1.112,7.912-2.184,8.859-1.446,1.5-1.079,15.683-1.416,17.741",
    transform: "translate(-136.684 -57.003)",
    fill: "#d9b380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M510.487,274.823s-7.4-1.1-10.2-6-1-13.6-1-13.6a49.182,49.182,0,0,1-4-10.2,47.867,47.867,0,0,1-1.2-10.8s2.6-12.8,4.2-40.4,6.128-32,9.666-34.276,8.315-4.2,10.591-.667c.433-5.648,6.195-7.526,11.646-9.065s11.239-.93,16.9-.671,11.933,3.25,11.933,3.25a25.326,25.326,0,0,1,9.292,8.952c3.567,6.057,5,15.052,5,15.052s-6.682,14.294-6.941,12.653c-.607-3.843,2.537,9.922,0,6.972s4.721-1.465,1.116,0c-2.022.822-.8.8-11-2.2-13-4.6-16.6-12-20.8-15.49s-11.149-7.471-15.6-7.977c-2.787-.317-4.025,11.293-9.6,16.868-1.443,1.5-2-3.4,0,0",
    transform: "translate(-136.684 -57.003)",
    fill: "#d9b380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M493.353,257.163s7.278-1.456,11.644,11.644,20.378,62.588,20.378,71.322c0,3.886,3.735,23.466-5.174,22.718-10.441-.876-34-22.718-34-22.718l-3.667-8.282,7.333-16.333Z",
    transform: "translate(-43.864 -60.161)",
    fill: "#f28482"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(412.163 259.236)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M371.978,126.877",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M29.892,0C46.4,0,59.783,8.79,59.783,19.633c0,7.189-1.767-1.926-10.651-9.478-4.353-3.7-13.677-7.616-19.241-7.616-6.092,0-14.437,2.274-19.241,6.6C2.649,16.346,0,26.475,0,19.633,0,8.79,13.383,0,29.892,0Z",
    transform: "translate(369.872 102.771)",
    fill: "#bc5d5d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.2558e76e07c60f644447438eac7fc4d8.svg";
export { ForwardRef as ReactComponent };